import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceWhitespaces',
})
export class ReplaceWhitespacesPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\s/g, '_');
  }
}
